import { render, staticRenderFns } from "./Userinfo.vue?vue&type=template&id=ce7654a0&scoped=true&"
import script from "./Userinfo.vue?vue&type=script&lang=js&"
export * from "./Userinfo.vue?vue&type=script&lang=js&"
import style0 from "./Userinfo.vue?vue&type=style&index=0&id=ce7654a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7654a0",
  null
  
)

export default component.exports